"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorH5 = exports.InputDiv = exports.BlackOutlinedButton = exports.SubTitle = exports.Title = exports.Wrapper = void 0;
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const styled_1 = __importDefault(require("@emotion/styled"));
exports.Wrapper = styled_1.default.div `
  width: 100%;
  padding: 0 20px 20px;
  button {
    white-space: pre-wrap;
  }
`;
exports.Title = (0, styled_1.default)(Grid_1.default) `
  align-items: center;
  column-gap: 10px;
  padding-top: 60px;
  font-weight: 700;
  font-size: 26px;
  line-height: 42px;
  word-break: keep-all;
`;
exports.SubTitle = styled_1.default.div `
  padding-top: 12px;
  color: var(--gray-30);
  font-size: 16px;
  line-height: 26px;
  > span {
    font-weight: 700;
    font-size: 16px;
  }
`;
exports.BlackOutlinedButton = (0, styled_1.default)(Button_1.default) `
  height: 50px;
  padding: 6px;
  border: 1px solid var(--gray-80);
  border-radius: 6px;
  background-color: var(--white) !important;
  color: var(--gray-80);
  box-shadow: 0px 5px 10px var(--gray-10);
`;
exports.InputDiv = styled_1.default.div `
  position: relative;
  display: flex;
  flex-wrap: wrap;
  border-radius: 6px;
  border: 1px solid var(--gray-80);
  margin-top: 60px;
`;
exports.ErrorH5 = styled_1.default.h5 `
  color: var(--error-main);
  margin-top: 4px;
  text-align: right;
  font-size: 12px;
`;
